module.exports = __webpack_public_path__ + "static/media/5.210b2a2f.jpg";